import { render, staticRenderFns } from "./base-field.vue?vue&type=template&id=4d59b5f0&scoped=true&"
import script from "./base-field.vue?vue&type=script&lang=js&"
export * from "./base-field.vue?vue&type=script&lang=js&"
import style0 from "./base-field.vue?vue&type=style&index=0&id=4d59b5f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d59b5f0",
  null
  
)

export default component.exports